import Assessment from '../assessment';

/**
 * Create the action
 */

const { thunk, request, success, error } = Assessment.store((data, fetch) =>
  // Prepare request
  fetch.post('/assessments', data)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
